import { Button, DataGrid, ScrollView } from "devextreme-react";
import { Column } from "devextreme-react/data-grid";
import CustomStore from "devextreme/data/custom_store";
import { useRef, useState } from "react";
import { useSelector } from "react-redux";
import { Modal } from "../../../components";
import { getApiParams } from "../../../redux/auth";
import { BodyType, createRequest } from "../../../redux/base/request";
import { getLocalized } from "../../../redux/localization";
import BaseService from "../../../services";
import { adminPendingContracts } from "../../../services/urls";
import { ApiResponse, verfiyResponse } from "../../../types/models/base-model";
import ContractDetail from "../../contracts/detail";
import { Contract } from "../../contracts/type";
import { User } from "../product-comment/type";

const DashboardPendingContracts = (title: any) => {
  const localize = useSelector(getLocalized);
  const [show, setShow] = useState(false);
  const { token, lang } = useSelector(getApiParams);
  const [user, setUser] = useState<User>();
  const baseService = new BaseService();
  const tableRef = useRef<any>();
  const data = useRef<Contract>({
    Code: "",
    Id: "",
    StartDate: "",
    EndDate: "",
    ContractStatusType: "",
    ContractStatusTypeId: 0,
    Amount: 0,
    ContractPaymentType: null,
    Product: {},
    Message: "",
    MessageDate: "",
    UnreadCount: 0,
    UserId: "",
    UserName: "",
    SupplierAccount: {},
    CustomerUser: {},
  });
  const columns = [
    {
      dataField: "Code",
      caption: localize.getString("code"),
    },
    {
      dataField: "SupplierAccount.AccountName",
      caption: localize.getString("supplier"),
    },

    {
      dataField: "CustomerUser.Name",
      caption: localize.getString("customerName"),
    },
    {
      dataField: "Product.Name",
      caption: localize.getString("productCardName"),
    },
    {
      dataField: "Amount",
      caption: localize.getString("amount"),
    },
    {
      dataField: "ContractStatusType",
      caption: localize.getString("contractStatusType"),
    },
    {
      dataField: "StartDate",
      caption: localize.getString("startDate"),
      dataType: "date",
    },
    {
      type: "buttons",
      width: 110,
      buttons: [
        {
          hint: "Detaya git",
          icon: "info",
          onClick: async (e: any) => {
            data.current = await e.row.data;
            setShow(true);
            const response: ApiResponse<User[]> = await createRequest({
              method: "GET",
              url: "/api/admin/accounts/get-user/" + data.current.UserId,
              bodyType: BodyType.formdata,
              token,
              body: {},
              lang,
            });
            if (verfiyResponse(response)) {
              setUser(response.Result[0]);
            }
          },
        },
      ],
    },
  ];

  return (
    <>
      <Modal
        coverModal={false}
        width={"50%"}
        visible={show}
        onHiding={() => setShow(false)}
        title={title}
        height={"90%"}
        onSubmitClick={async () => {
          console.log("ok");
        }}
      >
        <ContractDetail data={data.current} user={user} />
      </Modal>
      <div className="dx-card" style={{ backgroundColor: "white" }}>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            textAlign: "start",
            fontSize: "16px",
            fontWeight: 700,
            paddingInline: 10,
            marginBlock: "5px 5px",
          }}
        >
          <p style={{ color: "#434D6E" }}>Onay Bekleyen Kontratlar</p>
          <Button
            hint={"Yenile"}
            icon="refresh"
            type="normal"
            stylingMode="outlined"
            onClick={() => tableRef?.current?._instance?.refresh()}
          />
        </div>
        <div className="grid-div">
          <ScrollView>
            <DataGrid
              ref={tableRef}
              style={{ fontSize: 12 }}
              key="Id"
              className={"custom-data-grid wide-card dashboard-grid"}
              dataSource={
                new CustomStore({
                  key: "Id",
                  //@ts-ignore
                  load: () =>
                    baseService.sendRequest(
                      adminPendingContracts,
                      "GET",
                      token,
                      "tr-TR"
                    ),
                })
              }
              showBorders
              showRowLines
              showColumnLines={false}
              columnAutoWidth
              columnHidingEnabled
              rowAlternationEnabled
              allowColumnResizing
              allowColumnReordering
              focusedRowEnabled
              grouping={{
                autoExpandAll: false,
              }}
            >
              {columns.map((column, i) => (
                <Column key={i} {...column} />
              ))}
            </DataGrid>
          </ScrollView>
        </div>
      </div>
    </>
  );
};

export default DashboardPendingContracts;
